module.exports = __webpack_public_path__ + "media/service_features/number_03-0ad245e1.svg";